import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

// third-party modules
import { TranslateModule } from '@ngx-translate/core';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { NgxsModule } from '@ngxs/store';
import { CourtEventModalsState } from './+store/court-event-modals.state';

import { BcRecurringModule } from '@bayclubs/recurring';
import { SharedModule } from '../shared/shared.module';

// containers
import { SpinnerModule } from '@bayclubs/spinner';
import { BlockedSlotCancelReasonModalComponent } from './containers/blocked-slot-cancel-reason-modal/blocked-slot-cancel-reason-modal.component';
import { BlockedSlotEditConfirmationModalComponent } from './containers/blocked-slot-edit-confirmation-modal/blocked-slot-edit-confirmation-modal.component';
import { CourtBookingCancelReasonModalComponent } from './containers/court-booking-cancel-reason-modal/court-booking-cancel-reason-modal.component';


@NgModule({
    declarations: [
        CourtBookingCancelReasonModalComponent,
        BlockedSlotCancelReasonModalComponent,
        BlockedSlotEditConfirmationModalComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        NgxsModule.forFeature([CourtEventModalsState]),
        NgxsFormPluginModule,
        TranslateModule,
        BcRecurringModule,
        SharedModule,
        SpinnerModule
    ]
})
export class CourtEventModalsModule { }

export * from './services/cancel-court-event-launcher.service';
export * from './services/edit-blocked-slot-launcher.service';

export * from './+store/court-event-modals.actions';
export * from './models/blocked-slot-cancel-input.model';
export { EditBlockedSlotMode } from './models/edit-blocked-slot-confirmation-form.model';

